<mat-autocomplete
  requireSelection
  autoActiveFirstOption
  [displayWith]="activeOptionLabel"
  #auto="matAutocomplete"
  [autoActiveFirstOption]="autoActiveFirstOption"
>
  @for (c of filteredChoices$ | async; track c) {
  <mat-option [value]="c">
    @if (choiceOptionTemplate) {
    <ng-container
      [ngTemplateOutlet]="choiceOptionTemplate"
      [ngTemplateOutletContext]="{ $implicit: c }"
    >
    </ng-container>
    } @else { {{ c.name }} }
  </mat-option>
  }
</mat-autocomplete>
<input
  type="text"
  matInput
  (blur)="onTouched()"
  (input)="onTextInput($event)"
  (keydown.enter)="onPressEnter()"
  [formControl]="internalControl"
  [matAutocomplete]="auto"
/>
